import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjvpnakjrd: FaireProductEntity = {
  token: "p_yjvpnakjrd",
  type: "product",
  name: "heart topiary watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/883c98809e33f7f6ac12b0bc27c59cb19c04d63eede2a9e1b191bda95cec0617.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    'Display this lovely print of a heart-shaped topiary for seasonal delight.\n\nDetails: \n- 8"x10" print of original watercolor artwork by Emily Lex\n- Printed in full color on thick, superfine paper\n- Packaged in a clear protective sleeve with chipboard backing\n- Frame and mat not included\n',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:09.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
